module.exports = __webpack_public_path__ + "img/logo.de6401ef.svg";